import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const requestPasswordResetFormSchema = z.object({
  email: z.string().email(ErrorMessages.Email.INVALID_SCHOOL),
});

export type RequestPasswordResetFormData = z.TypeOf<
  typeof requestPasswordResetFormSchema
>;
